var map = {
	"./bg_num_bata.png": "425c",
	"./上海.png": "a413",
	"./云南.png": "5761",
	"./内蒙古.png": "cefc",
	"./北京.png": "42ed",
	"./台湾.png": "e804",
	"./吉林.png": "77b0",
	"./四川.png": "3a38",
	"./天津.png": "6781",
	"./宁夏.png": "d476",
	"./安徽.png": "0569",
	"./山东.png": "2819",
	"./山西.png": "0d7f2",
	"./广东.png": "8c33",
	"./广西.png": "c939",
	"./新疆.png": "8c0e",
	"./江苏.png": "7d32",
	"./江西.png": "910a",
	"./河北.png": "2c2e",
	"./河南.png": "14d1",
	"./浙江.png": "e8e1",
	"./海南.png": "28fd",
	"./湖北.png": "2732",
	"./湖南.png": "1d35",
	"./澳门.png": "5654",
	"./甘肃.png": "5e03",
	"./福建.png": "4b48",
	"./西藏.png": "21a9",
	"./贵州.png": "cf27",
	"./辽宁.png": "3ac0",
	"./重庆.png": "034c",
	"./陕西.png": "b44b",
	"./青海.png": "e8932",
	"./香港.png": "c657",
	"./黑龙江.png": "337c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f8a7";